import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NavLink as Link } from 'react-router-dom';
import classNames from 'classnames';
import AppendJobEditor from 'app/Contacts/AppendJobEditor';
import { getBrandCode, getBrandHelpUrl, getBrandLogoUrl, getBrandSmallLogoUrl, getBrandLogoAltUrl } from 'utils/brand';
import { closeAllPopup } from '../../PopupHolder';
import { selectSmsEnabled, selectSmsRegistered } from 'data/campaigns';
import { authenticate, logout } from 'data/user';
import ListManagementInfo from 'app/components/ListManagementInfo';
import LaunchControlInfo from 'app/components/LaunchControlInfo';
import UpgradeAccount from 'app/components/UpgradeAccount';
import LoanApplication from 'app/components/LoanApplication';
import SVG from 'components/base/SVG';
import Image from 'components/base/Image';
import RestrictedContent from 'app/components/RestrictedContent';
import { Permissions } from 'data/user/constants';
import { selectProfile, selectIsLoading, setChatVisible } from 'data/user';
import { withRouter } from 'react-router-dom';
import NoLogo from "../../../assets/images/NoLogo.svg";
import NoLogoHover from "../../../assets/images/NoLogoHover.svg";
import css from './style.scss';


const Sidebar = ({ profile, isLoading, smsEnabled, authenticate, logout, setChatVisible, closeAllPopup, history, openAppendJobEditor, openLaunchControlInfo, openLoanApplication, openListManagementInfo }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const handleContactAppendClick = () => {
    handleLinkClick();
    openAppendJobEditor();
  };

  const handleSmsClick = () => {
    handleLinkClick();
    openLaunchControlInfo();
  };

  const handleLoanApplicationClick = () => {
    openLoanApplication();
  };

  const handleChatClick = () => {
    setChatVisible(true);
  };

  const clearCookiesOnLogout = () => {
    sessionStorage.removeItem('isLoggedIn')
    sessionStorage.setItem('logOutClicked', JSON.stringify(true))
    // Clear all cookies
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
  }

  const handleTestClick = () => {
    openListManagementInfo();
  };

  const handleNavClick = (to) => {
    setTimeout(() => {
      history.push(to);
    }, 0);

    return handleLinkClick();
  };

  const handleLinkClick = () => {
    closeAllPopup();
    setChatVisible(false);

    return false;
  };

  const { logoUrl, logoHash, firstName, lastName, username } = profile.toJS();
  const [isHovered, setIsHovered] = useState(false);
  const queryParams = [`t=${logoHash}`];

  let fullName = `${firstName || ''} ${lastName || ''}`.trim();
  if (fullName === '') fullName = username;



  return (
    <section className={css.container} id="left-sidebar">
      {isLoading ? null : (
        <div className={css.info}>
          <div className={css.logoContainer}>
            <Image src={getBrandLogoUrl()} placeholder={getBrandLogoAltUrl()} className={css.logo} />
            <Image src={getBrandSmallLogoUrl()} placeholder={getBrandLogoUrl()} className={css.logoSmall} />
          </div>
          {getBrandCode() !== 'propstream' ? (
            <Link to="/account/profile" className={classNames(css.toggle)} onClick={() => handleNavClick('/account/profile')}>
              <div className={css.profileContainer}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <div className={css.profileImageWrapper}
                >
                  <Image
                    src={logoUrl.includes("/defaultLogo") ? (isHovered ? NoLogoHover : NoLogo) : `${logoUrl}?${encodeURIComponent(queryParams.join('&'))}`}
                    alt={fullName}
                    className={css.profileImage} />
                </div>
                <div className={css.profileNames}>
                  <span className={classNames(css.whiteSpace, css.firstName)}>{firstName}</span>
                  <span className={classNames(css.whiteSpace, css.lastName)}>{lastName}</span>
                </div>
              </div>
            </Link>
          ) : null}
          {getBrandCode() == 'propstream' ? (
            <Link to="/accountnew" className={classNames(css.toggle)} onClick={() => handleNavClick('/accountnew')}>
              <div className={css.profileContainer}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <div className={css.profileImageWrapper}
                >
                  <Image
                    src={logoUrl.includes("/defaultLogo") ? (isHovered ? NoLogoHover : NoLogo) : `${logoUrl}?${encodeURIComponent(queryParams.join('&'))}`}
                    alt={fullName}
                    className={css.profileImage} />
                </div>
                <div className={css.profileNames}>
                  <span className={classNames(css.whiteSpace, css.firstName)}>{firstName}</span>
                  <span className={classNames(css.whiteSpace, css.lastName)}>{lastName}</span>
                  {/* <SVG icon="iconCaretDown" className={css.iconCaret} /> */}
                </div>
              </div>
            </Link>
          ) : null}
        </div>
      )}
      <div className={css.nav}>
        <ul>
          <li onMouseEnter={() => setHoveredItem('search')} onMouseLeave={() => setHoveredItem(null)}>
            <Link className={window.location.pathname.includes('/search') ? css.activeItem : ''} to="/search" onClick={() => handleNavClick('/search')}>
              <SVG
                icon={hoveredItem === 'search'
                  ? 'iconSearchSidebarHover'
                  : window.location.pathname.includes('/search') ? 'iconSearchSidebarActive'
                    : 'iconSearchSidebar'} className={css.iconSearch}
              />
              <span>Search</span>
            </Link>
          </li>
          <li onMouseEnter={() => setHoveredItem('home')} onMouseLeave={() => setHoveredItem(null)}>
            <Link activeClassName={css.activeItem} to="/property/group/0" isActive={(match, location) => location.pathname.startsWith('/property/group')} onClick={() => handleNavClick('/property/group/0')}>
              <SVG
                icon={
                  hoveredItem === 'home'
                    ? 'iconHomeHover'
                    : window.location.pathname.startsWith('/property/group')
                      ? 'iconHomeActive'
                      : 'iconHome'
                }
                className={css.iconProperties}
              />
              <span>My Properties</span>
            </Link>
          </li>
          <li onMouseEnter={() => setHoveredItem('contact')} onMouseLeave={() => setHoveredItem(null)}>
            <RestrictedContent permission={Permissions.contactView}>
              <Link activeClassName={css.activeItem} to="/contact/0" isActive={(match, location) => location.pathname.startsWith('/contact')} onClick={() => handleNavClick('/contact/0')}>
                <SVG
                  icon={
                    hoveredItem === 'contact'
                      ? 'iconContactHover'
                      : window.location.pathname.startsWith('/contact')
                        ? 'iconContactActive'
                        : 'iconContact'
                  }
                  className={css.iconContacts}
                />
                <span>Contacts</span>
              </Link>
            </RestrictedContent>
          </li>
          {false && (<li onMouseEnter={() => setHoveredItem('skiptracing')} onMouseLeave={() => setHoveredItem(null)}>
            <RestrictedContent permission={Permissions.contactView}>
              <a onClick={handleContactAppendClick}>
                <SVG
                  icon={
                    hoveredItem === 'skiptracing'
                      ? 'iconZoomHover'
                      : 'iconZoom'
                  }
                  className={css.iconContacts}
                />
                <span>Skip Tracing</span>
              </a>
            </RestrictedContent>
          </li>)}
          {!smsEnabled ? null : (
            <li onMouseEnter={() => setHoveredItem('smsbeta')} onMouseLeave={() => setHoveredItem(null)}>
              <a onClick={handleSmsClick}>
                <SVG
                  icon={
                    hoveredItem === 'smsbeta'
                      ? 'iconSmsBetaHover'
                      : 'iconSmsBeta'
                  }
                  className={css.iconCampaigns}
                />
                <span>SMS (Beta)</span>
              </a>
            </li>
          )}
          <li onMouseEnter={() => setHoveredItem('campaigns')} onMouseLeave={() => setHoveredItem(null)}>
            <RestrictedContent permission={Permissions.marketingView}>
              <Link activeClassName={css.activeItem} to="/campaign" onClick={() => handleNavClick('/campaign')}>
                <SVG
                  icon={
                    hoveredItem === 'campaigns'
                      ? 'iconSpeakerHover'
                      : window.location.pathname.startsWith('/campaign')
                        ? 'iconSpeakerActive'
                        : 'iconSpeaker'
                  }
                  className={css.iconCampaigns}
                />
                <span>Campaigns</span>
              </Link>
            </RestrictedContent>
          </li>

          <li onMouseEnter={() => setHoveredItem('batchdialer')} onMouseLeave={() => setHoveredItem(null)}>
            <RestrictedContent permission={Permissions.marketingView}>
              <a
                href="https://batchdialer.com/propstream?utm_source=inapp&utm_medium=sidebar&utm_campaign=lp"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                <SVG
                  icon={
                    hoveredItem === 'batchdialer'
                      ? 'iconBatchDialerHover'
                      : 'iconBatchDialer'
                  }
                  className={css.iconCampaigns}
                />
                <span>BatchDialer</span>
              </a>
            </RestrictedContent>
          </li>

          {getBrandCode() == 'propstream' ? null : (
            <li onMouseEnter={() => setHoveredItem('settings')} onMouseLeave={() => setHoveredItem(null)}>
              <Link activeClassName={css.activeItem} to="/account/profile" onClick={() => handleNavClick('/account/profile')}>
                <SVG
                  icon={
                    hoveredItem === 'settings'
                      ? 'iconSettingHover'
                      : window.location.pathname === '/account/profile'
                        ? 'iconSettingActive'
                        : 'iconSetting'
                  }
                  className={css.iconProperties}
                />
                <span>Account</span>
              </Link>
            </li>
          )}
          {getBrandCode() !== 'propstream' ? null : (
            <li onMouseEnter={() => setHoveredItem('account')} onMouseLeave={() => setHoveredItem(null)}>
              <Link className={window.location.pathname.includes('/accountnew') ? css.activeItem : ''} to="/accountnew/landing" onClick={() => handleNavClick('/accountnew/landing')}>
                <SVG
                  icon={
                    hoveredItem === 'account'
                      ? 'iconSettingHover'
                      : window.location.pathname.includes('/accountnew')
                        ? 'iconSettingActive'
                        : 'iconSetting'
                  }
                  className={css.iconProperties}
                />
                <span>Account</span>
              </Link>
            </li>
          )}

          {getBrandCode() !== 'lenderdemo' ? null : (
            <li>
              <a onClick={handleLoanApplicationClick}>
                <SVG icon="iconMoney" className={css.iconMoney} />
                <span>Lending</span>
              </a>
            </li>
          )}
          <li onMouseEnter={() => setHoveredItem('logout')} onMouseLeave={() => setHoveredItem(null)}>
            <Link to="/logout" onClick={() => handleNavClick('/logout')}>
              <SVG
                icon={
                  hoveredItem === 'logout'
                    ? 'iconloginHover'
                    : window.location.pathname === '/logout'
                      ? 'iconloginActive'
                      : 'iconlogin'
                }
                className={css.iconlogout}
              />
              <span>Log Out</span>
            </Link>
          </li>
          {process.env.NODE_ENV !== 'dev-server' ? null : (
            <li>
              <a onClick={handleTestClick}>
                <span>Test</span>
              </a>
            </li>
          )}
        </ul>
        <ul>
          {/* {getBrandCode() !== 'propstream' ? null : ( */}
          <>
            <li onMouseEnter={() => setHoveredItem('help')} onMouseLeave={() => setHoveredItem(null)}>
              <a target="help" href={getBrandHelpUrl()} className={window.location.pathname === '/help' ? css.activeItem : ''}>
                <SVG
                  icon={hoveredItem === 'help' ? 'iconQuestionHover' : window.location.pathname === '/help' ? 'iconQuestionActive' : 'iconQuestion'}
                  className={css.iconQuestion}
                />
                <span>Help</span>
              </a>
            </li>
            <li onMouseEnter={() => setHoveredItem('academy')} onMouseLeave={() => setHoveredItem(null)}>
              <a target="academy" href={"https://theacademy.propstream.com/learn"} className={window.location.pathname === '/academy' ? css.activeItem : ''}>
                <SVG
                  icon={hoveredItem === 'academy' ? 'academysidebarWhite' : 'academysidebar'}
                  className={css.iconAcademy}
                />
                <span>Academy</span>
              </a>
            </li>
            <li className="chat-support" onMouseEnter={() => setHoveredItem('chat-support')} onMouseLeave={() => setHoveredItem(null)}>
              <a onClick={handleChatClick}>
                <SVG
                  icon={hoveredItem === 'chat-support' ? 'chartsidebarWhite' : 'chartsidebar'}
                  className={css.iconChat}
                />
                <span>Chat Support</span>
              </a>
            </li>
          </>
          {/* )} */}
        </ul>

        <ul>
          {}
          <>
            <li onMouseEnter={() => setHoveredItem('cookie-settings')} onMouseLeave={() => setHoveredItem(null)}>
              <a onClick={()=> OneTrust.ToggleInfoDisplay()}>
                <SVG
                  icon={hoveredItem === 'cookie-settings' ? 'privacy-white' : 'privacy'}
                  className={css.iconChat}
                />
                <span>Privacy</span>
              </a>
            </li>

          </>
          {/* )} */}
        </ul>
      </div>
    </section>
  );
};

export default withRouter(connect((state) => ({
  smsEnabled: selectSmsEnabled(state),
  profile: selectProfile(state),
  isLoading: selectIsLoading(state),
}), {
  authenticate,
  logout,
  setChatVisible,
  closeAllPopup,
  openAppendJobEditor: AppendJobEditor.open,
  closeAppendJobEditor: AppendJobEditor.close,
  openUpgradeAccount: UpgradeAccount.open,
  openLoanApplication: LoanApplication.open,
  openListManagementInfo: ListManagementInfo.open,
  openLaunchControlInfo: LaunchControlInfo.open,
})(Sidebar));
